<template>
    <div>
 <h3>Правила игры &laquo;Автоматизация Нового года 2023&raquo;</h3>

<p><strong>Старт игры.</strong> Для старта игры или, чтобы начать новую игру, нажмите &laquo;Начать новую игру&raquo; на главном экране.</p>

<p><strong>Цель игры:</strong> выполнить все задания из &laquo;Списка дел&raquo; в правой части экрана. Общее количество заданий &ndash; 9 шт.</p>

<p>&nbsp;</p>

<h3>Игровой процесс</h3>

<p>Выберите задание из списка справа, нажав на него.</p>

<p>В диалоге с Дедом Морозом будет написано условие задания. Нужно подобрать оборудование ОВЕН согласно условию.</p>

<p>В списке приборов слева представлены приборы, которые доступны для выполнения задания.</p>

<p>Чтобы выполнить задание, переместите приборы из списка слева в серые рамки справа. Если комбинация окажется верной, рамки станут зелеными, и Дед Мороз поблагодарит за решение задачи. Если комбинация окажется неверной, рамки станут красными, и Дед Мороз попросит попробовать еще раз.</p>

<p>Если комбинация приборов оказалась неверной, переместите приборы в список приборов. После этого можно попробовать еще раз.</p>

<p>Задание считается выполненным, если в списке дел оно отмечено зеленой галочкой.</p>

<p><strong>Подсказка</strong></p>

<p>Выполнять задания можно в любом порядке! Если какое-то задание не получается выполнить, пропустите его.</p>

<p>Для подбора правильной модификации прибора можно воспользоваться <a href="https://owen.ru/" target="_blank">сайтом ОВЕН</a>.</p>

<p><strong>Завершение игры</strong></p>

<p>Игрок, который выполнит все задания из списка дел, считается <strong>знатоком ОВЕН.</strong></p>

<p>Количество попыток подбора оборудования и время игры не ограничено.</p>

<p>Вы всегда можете начать игру сначала, нажав соответствующую кнопку.</p>

<p>Всем удачи!</p>

<p>&nbsp;</p>

<h3>Игра на приз</h3>

<p>С 29 декабря 2022 года до 9 января 23:59 час. 2023 года по МСК UTC+4 проводится конкурс с награждением победителей ценными призами.</p>

<p>Победителями считаются пять игроков, выполнивших условия:</p>

<ul>
    <li>приложили скрин из игры в комментарий к посту с анонсом игры во <a href="https://vk.com/po_owen" target="_blank">В Контакте</a>;</li>
    <li>поставили лайк и сделали репост поста с анонсом игры.</li>
</ul>

<p>Количество комментариев не ограничено, один пользователь может оставить только один комментарий.</p>

<p><strong>Призы</strong></p>

<p>Шарф ОВЕН с фирменным шевроном, календарь квартальный ОВЕН 2023 &ndash; 5 шт.</p>

<p>Соревнование проводится только среди жителей России. Принять участие в соревновании могут пользователи, зарегистрированные В Контакте.</p>

<p>Итоги игры мы подведем 10 января 2023 среди комментариев под постом с анонсом игры с помощью генератора случайных чисел. Каждому комментарию будет присвоен номер.</p>

<p>Имена победителей будут опубликованы в официальной группе ОВЕН В Контакте.</p>

<p>Для победителей мы обеспечим бесплатную доставку призов. Сотрудники компании ОВЕН и их ближайшие родственники не могут считаться победителями.</p>

<p>P.S. Компания ОВЕН оставляет за собой право удалить ваш результат из турнирной таблицы в случае фиксации некорректного поведения.</p>

<p>&nbsp;</p>

<h3>Конец игры</h3>

<p>Благодарим за выполнение всех заданий, благодаря тебе и приборам ОВЕН Новый год под контролем!</p>

<p>Пусть следующий год будет счастливым и удачным, наполнен любовью и заботой близких людей, счастливыми моментами, приятными знакомствами. Пусть все, о чем ты мечтаешь, обязательно сбудется.</p>

<p>&nbsp;</p>

<p>С Новым годом!</p>
</div>
</template>

<script>
export default{
    name: 'RelesText'
}
</script>